import widgetsService from 'live/services/widgets'
import locale from 'live/init/global-locale'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import i18n from 'live/services/i18n'
import GanttWidget from './GanttWidget'
import EditorService from 'live/services/editor'
import EditorGantt from './GanttEditor'
import { simpleReducer } from './reducer'

const type = 'gantt-operations'

const localeFiles = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    pt_br: require('./i18n/pt_br').default,
    // eslint-disable-next-line @typescript-eslint/camelcase
    en_us: require('./i18n/en_us').default
}

i18n.add(localeFiles[locale])

const OperationsGantt = {
    label: i18n('Operations gantt'),
    order: 23,
    type: `${type}-editor`,
    description: i18n('Shows a gantt chart displaying the operations'),
    iconClass: 'far fa-tasks',
}

EditorService.newEditor({
    name: OperationsGantt.type,
    editor: EditorGantt,
    defaultWidgetType: type
})

EditorService.newEditorMenuOption(type, OperationsGantt)

const policies = {
    legends: true,
    restrictViewModeOptionsHeight: true,
    allowHideTooltip: false,
    handleOwnMissingData: true,
    allowXAxisConfig: false,
    allowYAxisConfig: false
}

widgetsService.impl(type, reactWidgetWrapper<ChartState, ChartMessage, Configs>(GanttWidget, simpleReducer))
widgetsService.queryHandlerKind(type, type)
widgetsService.policies(type, policies)
widgetsService.editor(type, OperationsGantt.type)
widgetsService.ui(type, { editor: OperationsGantt.type })
